function initHeroBanners(scope) {
  var banners = (scope || document).querySelectorAll('[data-hero-banner]');
 
  banners.forEach(function (banner) {
    if (banner.dataset.heroInit === 'true') return;
    banner.dataset.heroInit = 'true';
 
    var slides = Array.prototype.slice.call(banner.querySelectorAll('[data-hero-slide]'));
    if (slides.length === 0) return;
 
    var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-hero-dot]'));
    var viewport = banner.querySelector('[data-hero-viewport]');
 
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = banner.dataset.autoplay === 'true' && !prefersReducedMotion && slides.length > 1;
    var autoplaySpeed = parseInt(banner.dataset.autoplaySpeed, 10) || 5000;
    var pauseOnHover = banner.dataset.pauseOnHover === 'true';
 
    var currentIndex = 0;
    var timer = null;
    var isPaused = false;
 
    // Reads the currently-rendered image's real width/height (the browser
    // already picked mobile vs desktop via <picture>) and sizes the
    // viewport to match, so nothing is ever cropped.
    function updateViewportRatio(slide) {
      var img = slide.querySelector('[data-hero-image]');
      if (!img || !viewport) return;
      function apply() {
        if (img.naturalWidth && img.naturalHeight) {
          viewport.style.setProperty('--hero-current-ratio', img.naturalWidth + ' / ' + img.naturalHeight);
        }
      }
      if (img.complete) apply(); else img.addEventListener('load', apply, { once: true });
    }
 
    function setActiveSlide(nextIndex, direction) {
      var previousIndex = currentIndex;
      if (nextIndex === previousIndex) return;
 
      var prevSlide = slides[previousIndex];
      var nextSlide = slides[nextIndex];
 
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add(direction === 'prev' ? 'is-next' : 'is-prev');
      prevSlide.setAttribute('aria-hidden', 'true');
      prevSlide.setAttribute('tabindex', '-1');
 
      // Force reflow so the transition restarts cleanly.
      // eslint-disable-next-line no-unused-expressions
      void nextSlide.offsetWidth;
 
      nextSlide.classList.add('is-active');
      nextSlide.classList.remove('is-prev', 'is-next');
      nextSlide.setAttribute('aria-hidden', 'false');
      nextSlide.setAttribute('tabindex', '0');
 
      window.setTimeout(function () {
        prevSlide.classList.remove('is-prev', 'is-next');
      }, 700);
 
      updateViewportRatio(nextSlide);
 
      dots.forEach(function (dot, i) {
        var active = i === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
 
      currentIndex = nextIndex;
    }
 
    function goTo(index) {
      var total = slides.length;
      var normalized = ((index % total) + total) % total;
      var direction = normalized === (currentIndex + 1) % total ? 'next' : 'prev';
      setActiveSlide(normalized, direction);
    }
 
    function next() { goTo(currentIndex + 1); }
    function prev() { goTo(currentIndex - 1); }
 
    function startAutoplay() {
      if (!autoplayEnabled || isPaused) return;
      stopAutoplay();
      timer = window.setInterval(next, autoplaySpeed);
    }
 
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }
 
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });
 
    if (pauseOnHover) {
      banner.addEventListener('mouseenter', function () { isPaused = true; stopAutoplay(); });
      banner.addEventListener('mouseleave', function () { isPaused = false; startAutoplay(); });
      banner.addEventListener('focusin', function () { isPaused = true; stopAutoplay(); });
      banner.addEventListener('focusout', function () { isPaused = false; startAutoplay(); });
    }
 
    // Swipe support
    var touchStartX = 0;
    var touchDeltaX = 0;
 
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        stopAutoplay();
      }, { passive: true });
 
      viewport.addEventListener('touchmove', function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      }, { passive: true });
 
      viewport.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) > 40) {
          if (touchDeltaX < 0) next(); else prev();
        }
        startAutoplay();
      });
    }
 
    // Keyboard navigation when the banner has focus
    banner.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); startAutoplay(); }
      if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
    });
 
    // Recompute the ratio for the active slide when crossing the
    // mobile/desktop breakpoint, since <picture> can swap to a different
    // image with a different aspect ratio.
    var mq = window.matchMedia('(max-width: 749px)');
    var mqHandler = function () { updateViewportRatio(slides[currentIndex]); };
    if (mq.addEventListener) mq.addEventListener('change', mqHandler);
    else if (mq.addListener) mq.addListener(mqHandler);
 
    updateViewportRatio(slides[currentIndex]);
    startAutoplay();
  });
}
 
document.addEventListener('DOMContentLoaded', function () {
  initHeroBanners(document);
});
 
document.addEventListener('shopify:section:load', function (event) {
  var banner = event.target.querySelector('[data-hero-banner]');
  if (banner) banner.dataset.heroInit = '';
  initHeroBanners(event.target);
});
 